import React from 'react'
import { connect } from 'react-redux'
import EducationalMaterialsDiv from './EducationalMaterialsDiv'
import InternalExperienceDiv from './InternalExperienceDiv'
import ExternalExperienceDiv from './ExternalExperienceDiv'
import SalaryRatioDiv from './SalaryRatioDiv'
import PersonLoginDetail from './PersonLoginDetail'
import SalaryChangeLogDiv from './SalaryChangeLogDiv'
import ResponsibleDepSetDiv from './ResponsibleDepSetDiv'
import VacationDeductionInfoDiv from '../GiveVacationManagement/VacationDeductionInfoDiv'
import {
	addListItem, changeListItem, deleteListItem, getListFromValues,
	hasChangedValues, getFormValue, changeItemsValue, nullDate
} from '../../public/utility'

import { doGetPerson, doSavePerson, doDelPerson, doDeleteExternalExperience, doDeleteInternalExperience } from '../../reducers/actions'
import { concat } from 'lodash'


class PersonInfoDiv extends React.Component {
	state = {
	}

	SettingsDiv = {
		'学历资料': EducationalMaterialsDiv,
		'内部经历': InternalExperienceDiv,
		'外部经历': ExternalExperienceDiv,
		'薪资比例': SalaryRatioDiv,
		'帐号管理': PersonLoginDetail,
		'假期信息': VacationDeductionInfoDiv,
		'负责部门设置': ResponsibleDepSetDiv,
	}

	componentDidMount = () => {
		this.doGetPerson(this.props.id, '')
	}

	doGetPerson = (id, fieldsets) => {
		const { dispatch, teamID, depID, onClose } = this.props
		const roles = Tyan.loginInfo.roles
		const bReadOnly = roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1 && roles.indexOf('总部人事专员') == -1
		dispatch(doGetPerson({
			id: id || 0,
			teamID: teamID || 0,
			depID: depID || 0,
			onEnd: ({ errorMessage, depID, initValues基本信息, initValues帐号管理, initValues通讯资料, initValues在职资料, initValues薪资明细,
				initValues学历资料, initValues培训经历, initValues内部经历, initValues外部经历, initValues薪资比例, initValues有效假期信息, initValues失效假期信息, optionsParas
			}) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					onClose && onClose()
				} else {
					if (fieldsets == '') {
						this.setState({
							id, depID, changedValues基本信息: {}, optionsParas, changedValues通讯资料: {}, changedValues在职资料: {}, initValues基本信息, initValues帐号管理, initValues通讯资料, initValues在职资料, initValues薪资明细,
							initValues学历资料, initValues培训经历, initValues内部经历, initValues外部经历, initValues薪资比例, initValues有效假期信息, initValues失效假期信息, bReadOnly
						})
					} else if (fieldsets == '薪资明细') {
						this.setState({ id, depID, initValues薪资明细, bReadOnly })
					} else if (fieldsets == '学历资料') {
						this.setState({ id, depID, initValues学历资料, bReadOnly })
					} else if (fieldsets == '内部经历') {
						this.setState({ id, depID, initValues内部经历, initValues在职资料, bReadOnly })
					} else if (fieldsets == '外部经历') {
						this.setState({ id, depID, initValues外部经历, initValues在职资料, bReadOnly })
					} else if (fieldsets == '薪资比例') {
						this.setState({ id, depID, initValues薪资比例, bReadOnly })
					} else if (fieldsets == '帐号管理') {
						this.setState({ id, depID, initValues帐号管理, bReadOnly })
					}
				}
			}
		}))
	}

	handlerSave = () => {
		const { dispatch } = this.props
		const { id, depID, changedValues基本信息, changedValues通讯资料, changedValues在职资料 } = this.state
		const 性别 = getFormValue(this, '基本信息', '性别')
		const 身份证号 = getFormValue(this, '基本信息', '身份证号')
		const 挂职人员 = getFormValue(this, '基本信息', '挂职人员')
		if (性别 == '' && 挂职人员 !== '是') {
			if (身份证号.length !== 8) {
				Tyan.pubForm.showError('身份证号码有误')
				return
			}
		}

		const 加班折算方式 = getFormValue(this, '基本信息', '加班折算方式')
		if (加班折算方式.length > 1 && 加班折算方式.indexOf('无调休无薪资') > -1) {
			Tyan.pubForm.showError('无调休无薪资不能与其它项同时选择')
			return
		}
		dispatch(doSavePerson({
			id,
			depID,
			changedValues基本信息,
			changedValues通讯资料,
			changedValues在职资料,
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					Ext.toast('保存成功')
					this.doGetPerson(id, '')
				}
			}
		}))
	}

	handlerDelete = () => {
		const { dispatch, onClose, onSave } = this.props
		const { id } = this.state

		Tyan.pubForm.showConfirm('确定要删除？', () =>
			dispatch(doDelPerson({
				id,
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						onSave && onSave()
						onClose && onClose()
					}
				}
			})))
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}


	canSave = () => {
		const { initValues基本信息, changedValues基本信息 } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }

		return this.bChanged() && values.姓名 && values.人员编号 && values.籍别 && values.居民非居民 &&
			values.加班折算方式 && values.加班折算方式.length && (values.身份证号 || values.挂职人员 == '是') && (values.是否计薪 == '否' || values.社保缴纳方式) &&
			(values.挂职人员 == '是' || values.劳动合同开始日期 &&
				values.劳动合同开始日期 !== nullDate && ((values.劳动合同类型 == '固定期限' && values.劳动合同到期日期 &&
					values.劳动合同到期日期 !== nullDate) || values.劳动合同类型 == '无固定期限'))
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	handleShowDiv = (name, title, id, personID, bDelete) => {
		const { bReadOnly } = this.state
		const Comp = this.SettingsDiv[name]
		Tyan.pubForm.showDialog(title, Comp, { id: id, personID: personID, type: title, bDelete, bReadOnly, onRefresh: () => this.doGetPerson(personID, name) }, name == '假期信息' ? { height: 500, minWidth: 900 } : {})
	}

	handlerDeleteExternalExperience = (id) => {
		const { dispatch } = this.props
		dispatch(doDeleteExternalExperience({
			id: id || 0,
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('删除成功')
					this.doGetPerson(this.state.id, '外部经历')
				}
			}
		}))
	}

	handlerDeleteInternalExperience = (id) => {
		const { dispatch } = this.props
		dispatch(doDeleteInternalExperience({
			id: id || 0,
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('删除成功')
					this.doGetPerson(this.state.id, '内部经历')
				}
			}
		}))
	}

	handlerChangeICCard = idCard => {
		if (idCard && idCard.length !== 18 && idCard.length !== 10 && idCard.length !== 8) {
			changeItemsValue(this, '基本信息', '出生日期', nullDate)
			changeItemsValue(this, '基本信息', '性别', '')
			return
		}
		if (idCard.length === 18) {
			var sex = idCard.substring(16, 17);
			var num = idCard.substring(17, 18);
			var year = idCard.substring(6, 10);
			var month = idCard.substring(10, 12);
			var day = idCard.substring(12, 14);
			var age = year + "-" + month + "-" + day;
			var date = new Date(age);
			var sum = 0;
			var arr = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
			var arr2 = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
			for (var i = 0; i < 17; i++) {
				sum += idCard.substring(i, i + 1) * arr[i]
			}
			if (num == arr2[sum % 11] || num === arr2[sum % 11]) {
				changeItemsValue(this, '基本信息', '出生日期', date.valueOf())
				if (sex % 2 == 1) {
					changeItemsValue(this, '基本信息', '性别', '男')
				} else {
					changeItemsValue(this, '基本信息', '性别', '女')
				}
			} else {
				changeItemsValue(this, '基本信息', '出生日期', nullDate)
				changeItemsValue(this, '基本信息', '性别', '')
				return
			}
		}
		else if (idCard.length === 10) {
			var sex = idCard.substring(1, 2);
			if (sex % 2 == 1) {
				changeItemsValue(this, '基本信息', '性别', '男')
			} else {
				changeItemsValue(this, '基本信息', '性别', '女')
			}
		}
	}

	fieldset人员信息 = () => {
		const { initValues基本信息, changedValues基本信息 } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		const _fieldset = []
		const _items = []
		const 身份证号 = getFormValue(this, '基本信息', '身份证号')
		const 挂职人员 = getFormValue(this, '基本信息', '挂职人员')
		const 是否计薪 = getFormValue(this, '基本信息', '是否计薪')
		const 籍别 = getFormValue(this, '基本信息', '籍别')
		_items.push({ _text: '姓名', required: true, minWidth: '30%' },)
		_items.push({ _text: '英文名', minWidth: '30%' },)
		_items.push({ _text: '人员编号', required: true, minWidth: '30%' },)

		_items.push({ _checkbox: '加班折算方式', minWidth: '95%', required: true, items: ['无调休无薪资', '工作日调休', '工作日折算薪资', '非工作日调休', '非工作日折算薪资'] })
		_items.push({ _radio: '是否计薪', minWidth: '30%', itemMinWidth: '100', items: ['是', '否'] })
		if (是否计薪 == '是')
			_items.push({ _radio: '社保', name: '社保缴纳方式', minWidth: '30%', itemMinWidth: '100', items: ['含个人社保', '不含个人社保'] })

		_items.push({ _radio: '挂职人员', minWidth: '30%', itemMinWidth: '100', items: ['否', '是'] })

		if (values.挂职人员 == '否') {
			_items.push({ _radio: '劳动合同类型', minWidth: '30%', itemMinWidth: '100', items: ['固定期限', '无固定期限'] },)
			_items.push({ _date: '劳动合同开始日期', required: true, ...(values.劳动合同类型 == '固定期限' ? { minWidth: '30%' } : { minWidth: '60%', flex: 2 }) })
			if (values.劳动合同类型 == '固定期限')
				_items.push({ _date: '劳动合同到期日期', required: true, minWidth: '30%' })
		}

		_items.push({ _date: '出生日期', minWidth: '30%', disabled: 籍别 == '中华人民共和国' },)
		_items.push({ _select: '性别', minWidth: '30%'/* , itemMinWidth: 50 */, disabled: 身份证号 && 身份证号.length !== 8 },)
		_items.push({ _select: '籍别', minWidth: '30%', required: true, options: ['中华人民共和国', '中华民国', '中国台湾'] },)

		_items.push({ _select: '居民/非居民', name: '居民非居民', required: true, minWidth: '30%', options: ['居民', '非居民']/* , itemMinWidth: 50 */ },)
		_items.push({ _text: '出生地', minWidth: '30%' },)
		_items.push({ _text: '身份证号', minWidth: '30%', onChange: v => this.handlerChangeICCard(v), required: 挂职人员 !== '是' },)

		_items.push({ _text: '政治面貌', minWidth: '30%' },)
		_items.push({ _text: '护照号码', minWidth: '30%' },)
		_items.push({ _text: '护照姓名', minWidth: '30%' },)

		_items.push({ _text: '身高', minWidth: '30%' },)
		_items.push({ _text: '体重', minWidth: '30%' },)
		_items.push({ _text: '职称', minWidth: '30%' })

		_items.push({ _text: '婚姻状况', minWidth: '30%' })
		_items.push({ _text: '座机号码', name: '联系电话', minWidth: '30%' })
		_items.push({ _text: '手机号码', minWidth: '30%' })

		_items.push({ _text: '公司Email地址', name: 'Email地址', minWidth: '30%' })
		_items.push({ _text: '民族', minWidth: '30%' })
		if (values.籍别 == '中华民国')
			_items.push({ _select: '是否需要餐费补贴', minWidth: '30%', options: ['需要', '不需要'] },)

		_items.push({ _radio: '外地员工', minWidth: '30%', items: ['否', '是'] })

		_items.push({ _number: '排序', minWidth: '30%' })

		_items.push({ _checkbox: '所在小组', itemMinWidth: 100, items: values.items所在小组, minWidth: '95%' })

		_items.push({
			_group: '附件', minWidth: '95%', items: values.items附件.map(o => {
				return { _files: o, minWidth: '95%', multiple: true/*default*/, limit: 0/*default*/ }
			}).concat([{ _files: '其他资料', minWidth: '95%', multiple: true/*default*/, limit: 0/*default*/ }])
		})


		_fieldset.push({
			_group: '', name: '人员信息', minWidth: 'calc(100% - 300px)', margin: '0px 0px 0px 0px', items: _items
		})
		_fieldset.push({
			_group: '', name: '图片信息', minWidth: 300, maxWidth: 300, margin: '0px 0px 0px 0px', items: [
				{ _files: '照片', minWidth: '95%', labelAlign: 'top', labelTextAlign: 'center', margin: '0px 0px 0px 0px', imageSize: [150, 200], multiple: false, limit: 0, accept: 'image/*' },
				{
					_group: '', minWidth: '95%', margin: '20px 0px 0px 0px', items: [
						{ _files: '中文签名', minWidth: '95%', labelAlign: 'top', labelTextAlign: 'center', margin: '0px 0px 0px 0px', imageSize: [150, 100], multiple: false, limit: 0, accept: 'image/*', },
						{ _files: '英文签名', minWidth: '95%', labelAlign: 'top', labelTextAlign: 'center', margin: '0px 0px 0px 0px', imageSize: [150, 100], multiple: false, limit: 0, accept: 'image/*', },
					]
				}
			]
		})
		return _fieldset
	}
	fieldset通讯资料 = () => {
		const { initValues基本信息, changedValues基本信息 } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }

		const _fieldset = []
		_fieldset.push({
			_group: '员工通讯资料', name: '员工通讯资料', minWidth: '95%', margin: '0px 0px 0px 0px', items: [
				{ _text: '户籍电话', minWidth: '30%' },
				{ _text: '座机号码', name: '员工联系电话', minWidth: '30%' },
				{ _text: '户籍地址', minWidth: '34%' },

				{ _text: '邮政编码', name: '户籍邮政编码', minWidth: '30%' },
				{ _text: '通讯地址', name: '员工通讯地址', minWidth: '30%' },
				{ _text: '邮政编码', name: '通讯邮政编码', minWidth: '34%' },

				{ _text: '英文通讯地址', name: '员工英文通讯地址', minWidth: '30%' },
				{ _text: '个人邮箱', minWidth: '30%' },
			]
		},
			{
				_group: '紧急联络人通讯资料', name: '紧急联络人通讯资料', minWidth: '95%', margin: '0px 0px 0px 0px', items: [
					{ _text: '紧急联络人关系', minWidth: '30%' },
					{ _text: '紧急联络人姓名', minWidth: '30%' },
					{ _text: '通讯地址', name: '紧急联络人通讯地址', minWidth: '34%' },

					{ _text: '邮政编码', name: '紧急联络人邮政编码', minWidth: '30%' },
					{ _text: '英文通讯地址', name: '紧急联络人英文通讯地址', minWidth: '30%' },
					{ _text: '紧急联络人电话', minWidth: '34%' },
				]
			})
		return _fieldset
	}
	fieldset在职资料 = () => {
		const { initValues基本信息, changedValues基本信息 } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		const _fieldset = []
		_fieldset.push({
			_group: '', name: '在职资料', margin: '0px 0px 0px 0px', items: [
				{ _text: '部门名称', minWidth: '66%', disabled: true },
				{ _text: '部门代码', minWidth: '34%', disabled: true },

				{ _date: '入职日期', minWidth: '30%', disabled: true },
				{ _date: '试用期满日', minWidth: '30%', disabled: true },
				{ _date: '转正日期', minWidth: '34%', disabled: true },

				{ _text: '就职来源', minWidth: '30%', disabled: true },
				{ _text: '员工类别', minWidth: '30%', disabled: true },
				{ _date: '任职起日', minWidth: '34%', disabled: true },

				{ _text: '职等', minWidth: '30%', disabled: true },
				{ _text: '职务', minWidth: '30%', disabled: true },
				{ _text: '职级', minWidth: '34%', disabled: true },

				{ _text: '职类', minWidth: '30%', disabled: true },
				{ _text: '班别', minWidth: '30%', disabled: true },
				{ _text: '责任区分', minWidth: '34%', disabled: true },

				{ _text: '是否考勤', minWidth: '30%', disabled: true },
				{ _text: '工作区域', minWidth: '30%', disabled: true },
				{ _text: '工作地点', minWidth: '34%', disabled: true },

				{ _text: '变动原因', minWidth: '30%', disabled: true },
				{ _number: '工作年资（月）', name: '工作年资', minWidth: '30%', disabled: true },
				{ _number: '承认年资（月）', name: '承认年资', minWidth: '34%', disabled: true },

				{ _number: '工龄年资（月）', name: '工龄年资', minWidth: '30%', disabled: true },
				{ _date: '离职日期', minWidth: '30%', disabled: true },
				{ _text: '离职原因', minWidth: '34%', disabled: true },

				{ _text: '工资卡银行', minWidth: '30%' },
				{ _text: '银行卡号', minWidth: '30%' },
				{ _text: '备注', minWidth: '99%', maxRows: 3 },
			]
		})
		return _fieldset
	}
	fieldset薪资明细 = () => {
		const { id: personID } = this.state
		return [
			{
				_grid: '', name: '薪资明细', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '科目代码', minWidth: 150, flex: 1, },
					{ _text: '科目名称', minWidth: 150, flex: 1, },
					{ _text: '金额（元）/比例', name: '金额', minWidth: 150, flex: 1, align: 'right' },
					{ _text: '生效月份', minWidth: 150, flex: 1, },
					{
						_button: '变更日志', icon: 'edit', minWidth: 150, flex: 1, handler: (data, record) => {
							Tyan.pubForm.showDialog('岗位薪资变更日志', props => <SalaryChangeLogDiv {...props} subjectName={record.科目名称} personID={personID} />)
						}
					},
				],
				buttons: [
				],
			}]
	}
	fieldset学历资料 = () => {
		const { id: personID, bReadOnly } = this.state
		return [
			{
				_grid: '', name: '学历资料', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '学历', minWidth: 150, flex: 1, },
					{ _text: '学校名称（中文）', name: '学校名称中文', minWidth: 150, flex: 1, },
					{ _text: '学校名称（英文)', name: '学校名称英文', minWidth: 150, flex: 1, },
					{ _text: '毕业科系', minWidth: 150, flex: 1, },
					{ _text: '毕/结业', name: '毕结业', minWidth: 150, flex: 1, },
					{ _date: '入学日期', minWidth: 150, flex: 1, align: 'left' },
					{ _date: '离校日期', minWidth: 150, flex: 1, align: 'left' },
					{ _text: '备注', minWidth: 150, flex: 1, },
				],
				buttons: [
					{ _button: '添加...', icon: 'plus', handler: () => this.handleShowDiv('学历资料', '学历资料', 0, personID, true), cdt: () => !bReadOnly }
				],
				onDoubleTap: data => { this.handleShowDiv('学历资料', '学历资料', data.id, personID, true) },
			}]
	}
	fieldset培训经历 = () => {
		return [
			{
				_grid: '', name: '培训经历', rowNumbers: true, height: '100%',
				columns: [
					{ _date: '培训开始时间', minWidth: 150, flex: 1, align: 'left' },
					{ _date: '培训结束时间', minWidth: 150, flex: 1, align: 'left' },
					{ _text: '培训类别', minWidth: 150, flex: 1, },
					{ _text: '申请课程', minWidth: 150, flex: 1, },
					{ _text: '备注', minWidth: 150, flex: 1, },
				],
				buttons: [
				],
			}]
	}
	fieldset内部经历 = () => {
		const { id: personID, bReadOnly } = this.state
		const roles = Tyan.loginInfo.roles
		return [
			{
				_grid: '', name: '内部经历', rowNumbers: true, height: '100%',
				columns: [
					{ _date: '任职起日', minWidth: 150, flex: 1, align: 'left' },
					{ _text: '变动原因', minWidth: 150, flex: 1, },
					{ _date: '登记日期', minWidth: 150, flex: 1, align: 'left' },
					{ _text: '登记人', minWidth: 150, flex: 1, },
					{ _text: '备注', minWidth: 150, flex: 1, },
					// {
					//     _button: '删除', zone: 'end', hidden: (data) => !data.bDelete || bReadOnly,
					//     handler: (that, data, record) => Tyan.pubForm.showConfirm('确定要删除？', () => this.handlerDeleteInternalExperience(data.id))
					// },
				],
				buttons: [
					{ _button: '入职...', icon: 'plus', handler: () => this.handleShowDiv('内部经历', '入职', 0, personID, true), cdt: () => !bReadOnly && roles.includes('权限管理员') },
					{ _button: '变更...', icon: 'plus', handler: () => this.handleShowDiv('内部经历', '变更', 0, personID, true), cdt: () => !bReadOnly },
					{ _button: '离职...', icon: 'plus', handler: () => this.handleShowDiv('内部经历', '离职', 0, personID, true), cdt: () => !bReadOnly && roles.includes('权限管理员') }
				],
				onDoubleTap: data => { this.handleShowDiv('内部经历', data.Kind, data.id, personID, data.bDelete) },
			}]
	}
	fieldset外部经历 = () => {
		const { id: personID, bReadOnly } = this.state
		return [
			{
				_grid: '', name: '外部经历', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '公司名称', minWidth: 150, flex: 1, },
					{ _text: '部门名称', minWidth: 150, flex: 1, },
					{ _text: '职务名称', minWidth: 150, flex: 1, },
					{ _text: '职务内容', minWidth: 150, flex: 1, },
					{ _text: '月薪', minWidth: 150, flex: 1, },
					{ _text: '主管姓名', minWidth: 150, flex: 1, },
					{ _date: '到职日期', minWidth: 150, flex: 1, align: 'left' },
					{ _date: '离职日期', minWidth: 150, flex: 1, align: 'left' },
					{ _text: '备注', minWidth: 150, flex: 1, },
					{
						_button: '删除', zone: 'end', hidden: (data) => !data.bDelete || bReadOnly,
						handler: (that, data, record) => Tyan.pubForm.showConfirm('确定要删除？', () => this.handlerDeleteExternalExperience(data.id))
					},
				],
				buttons: [
					{ _button: '添加...', icon: 'plus', handler: () => this.handleShowDiv('外部经历', '外部经历', 0, personID, true), cdt: () => !bReadOnly }
				],
				onDoubleTap: data => { this.handleShowDiv('外部经历', '外部经历', data.id, personID, data.bDelete) },
			}]
	}
	fieldset薪资比例 = () => {
		const { id: personID, bReadOnly } = this.state
		return [
			{
				_grid: '', name: '薪资比例', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '生效月份', minWidth: 150, },
					{ _text: '备注', minWidth: 150, flex: 1, },
				],
				buttons: [
					{ _button: '添加...', icon: 'plus', handler: () => this.handleShowDiv('薪资比例', '薪资比例', 0, personID, true), cdt: () => !bReadOnly }
				],
				onDoubleTap: data => { this.handleShowDiv('薪资比例', '薪资比例', data.id, personID, true) },
			}]
	}
	fieldset有效假期信息 = () => {
		const { id: personID } = this.state
		return [
			{
				_grid: '', name: '有效假期信息', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '假期名称', minWidth: 150, flex: 1, },
					{ _float: '总时长（H）', name: '总时长', minWidth: 150, flex: 1, },
					{ _float: '已用时长（H）', name: '已用时长', minWidth: 150, flex: 1, },
					{ _float: '可用时长（H）', name: '可用时长', minWidth: 150, flex: 1, },
					{ _date: '生效日期', minWidth: 150, flex: 1, align: 'left' },
					{ _date: '有效日期', minWidth: 150, flex: 1, align: 'left' },
				],
				buttons: [
				],
				onDoubleTap: data => { this.handleShowDiv('假期信息', '假期明细', data.id, personID, data.bDelete) },
			}]
	}
	fieldset失效假期信息 = () => {
		const { id: personID } = this.state
		return [
			{
				_grid: '', name: '失效假期信息', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '假期名称', minWidth: 150, flex: 1, },
					{ _float: '总时长（H）', name: '总时长', minWidth: 150, flex: 1, },
					{ _float: '已用时长（H）', name: '已用时长', minWidth: 150, flex: 1, },
					{ _float: '可用时长（H）', name: '可用时长', minWidth: 150, flex: 1, },
					{ _date: '生效日期', minWidth: 150, flex: 1, align: 'left' },
					{ _date: '有效日期', minWidth: 150, flex: 1, align: 'left' },
				],
				buttons: [
				],
				onDoubleTap: data => { this.handleShowDiv('假期信息', '假期信息', data.id, personID, data.bDelete) },
			}]
	}
	fieldset帐号管理 = () => {
		const { id: personID, bReadOnly } = this.state

		return [
			{
				_grid: '', name: '帐号管理', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '帐号', minWidth: 150, },
					{ _text: '角色', minWidth: 150, flex: 1, renderer: v => v ? v.join('、') : '' },
					{
						_button: '设置', zone: 'end', hidden: (data) => bReadOnly,
						handler: (that, data, record) => this.handleShowDiv('负责部门设置', '负责部门设置', data.id, personID)
					},
				],
				buttons: [
					{ _button: '添加...', icon: 'plus', handler: () => this.handleShowDiv('帐号管理', '帐号管理', 0, personID, true), cdt: () => !bReadOnly }
				],
				onDoubleTap: data => { this.handleShowDiv('帐号管理', '帐号管理', data.id, personID, true) },
			}]
	}

	render() {
		const { showMessage: Message, showBody: Body } = this.props
		const { errorMessage, initValues基本信息, changedValues基本信息, id, bReadOnly } = this.state

		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		if (errorMessage) return <Message text={errorMessage} />
		return <Body data={this}
			controls={
				bReadOnly ?
					[
						{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
					] : [
						{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.canSave() },
						{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 && initValues基本信息["是否可删除"] },
						{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
					]}
			fieldsets={
				[
					id > 0 && {
						_fieldsets: [
							{ title: '假期信息（有效）', name: '有效假期信息', _fieldset: this.fieldset有效假期信息(), fullblock: true },
							{ title: '假期信息（失效）', name: '失效假期信息', _fieldset: this.fieldset失效假期信息(), fullblock: true },
							{ title: '内部经历', name: '内部经历', _fieldset: this.fieldset内部经历(), fullblock: true },
							{ title: '培训经历', name: '培训经历', _fieldset: this.fieldset培训经历(), fullblock: true },
							{ title: '学历资料', name: '学历资料', _fieldset: this.fieldset学历资料(), fullblock: true },
							{ title: '外部经历', name: '外部经历', _fieldset: this.fieldset外部经历(), fullblock: true },
							{ title: '薪资比例', name: '薪资比例', _fieldset: this.fieldset薪资比例(), fullblock: true },
							{ title: '薪资明细', name: '薪资明细', _fieldset: this.fieldset薪资明细(), fullblock: true, cdt: () => !bReadOnly },
							{ title: '帐号管理', name: '帐号管理', _fieldset: this.fieldset帐号管理(), fullblock: true, cdt: () => !bReadOnly },
						], height: '40%', docked: 'bottom', margin: '0 5 0 5',
					},
					{
						_fieldsets: [
							{ title: '基本信息', name: '基本信息', _fieldset: this.fieldset人员信息(), disabled: bReadOnly },
							{ title: '通讯资料', name: '通讯资料', _fieldset: this.fieldset通讯资料(), disabled: bReadOnly },
							{ title: '在职资料', name: '在职资料', _fieldset: this.fieldset在职资料(), disabled: bReadOnly },
						]
					}
				]}
		/>
	}
}

export default connect()(PersonInfoDiv)